
function addGTMContainerScript (bookingServicesContainerId, dataLayer) {
  var container = `(function(w,d,s,l,i){w[l]=w[l]||[];w[l].push({'gtm.start':`+
    `new Date().getTime(),event:'gtm.js'});var f=d.getElementsByTagName(s)[0],`+
    `j=d.createElement(s),dl=l!='dataLayer'?'&l='+l:'';j.async=true;j.src=`+
    `'https://www.googletagmanager.com/gtm.js?id='+i+dl;f.parentNode.insertBefore(j,f);`+
    `})(window,document,'script','${dataLayer}','${bookingServicesContainerId}');`

  var lastScriptTag=window.document.getElementsByTagName('script')[window.document.getElementsByTagName('script').length-1],
    scriptTagForGTM=window.document.createElement('script')
  scriptTagForGTM.appendChild(window.document.createTextNode(container))
  lastScriptTag.parentNode.insertBefore(scriptTagForGTM,lastScriptTag.nextSibling)
}

function addOptimizely (optimizelyId) {
  const firstScriptTag = window.document.querySelectorAll("head script:first-of-type")[0]
  const scriptTagForOptimize = window.document.createElement('script')
  scriptTagForOptimize.src = `https://cdn.optimizely.com/js/${optimizelyId}.js`
  firstScriptTag.parentNode.insertBefore(scriptTagForOptimize, firstScriptTag)
}

export const init = ({
  bookingServicesContainerIds,
  brandGtmContainerIds,
  brandBookingServicesContainerIds,
  whitelabelGtmContainerIds,
  optimizelyId,
}) => {
  if (optimizelyId) {
    addOptimizely(optimizelyId)
  }

  if (bookingServicesContainerIds) {
    bookingServicesContainerIds.forEach(bookingServicesContainerId => {
      addGTMContainerScript(bookingServicesContainerId, 'bookingServicesDataLayer')
    })
  }

  if (brandBookingServicesContainerIds) {
    brandBookingServicesContainerIds.forEach(brandBookingServicesContainerIds => {
      addGTMContainerScript(brandBookingServicesContainerIds, 'bookingServicesDataLayer')
    })
  }

  if (brandGtmContainerIds) {
    brandGtmContainerIds.forEach(brandGtmContainerId => {
      addGTMContainerScript(brandGtmContainerId, 'dataLayer')
    })
  }

  const urlSearchParams = new URLSearchParams(window.location.search)
  const isWhitelabel = urlSearchParams.get('ExternalRef') === 'TTCWEBWL' || urlSearchParams.get('skin')

  if (whitelabelGtmContainerIds && isWhitelabel) {
    whitelabelGtmContainerIds.forEach(whitelabelGtmContainerId => {
      addGTMContainerScript(whitelabelGtmContainerId, 'bookingServicesDataLayer')
    })
  }
}
